export default "data:application/javascript;base64,bW9kdWxlLmV4cG9ydHMgPSB7fTs="